// /* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */

import ValidationError from '../error/validation_error';
const typeString = ['[object String]', '[object Uint8Array]', '[object Object]'];
export default function validateColorScale(options) {
    const key = options.key;
    const value = options.value;
    const type = Object.prototype.toString.call(value);
    if (typeString.indexOf(type) < 0) {
        return [new ValidationError(key, value, 'colorscale expected, %s found', type)];
    }
    return [];
}
